<template>
  <div>
    <div
      v-if="singleLine"
      class="text-no-wrap"
    >
      <span :class="dateClass">
        {{ dateStr }}
      </span>
      <span :class="timeClass">
        {{ timeStr }}
      </span>
    </div>

    <div
      v-else
      :style="styles"
    >
      <div :class="dateClass">
        {{ dateStr }}
      </div>

      <div :class="timeClass">
        {{ timeStr }}
      </div>
    </div>
  </div>
</template>

<script>

import {splitDateTimeStrToObj} from '@/lib/helper/helper.js'

export default {
  name      : 'DisplayDateTime',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    dateTime: {
      type   : String,
      default: ''
    },

    dateClass: {
      type   : String,
      default: ''
    },

    timeClass: {
      type   : String,
      default: 'grey--text'
    },

    lineHeight: {
      type   : [Number, String],
      default: '14'
    },

    singleLine: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    dateStr() {
      return splitDateTimeStrToObj(this.dateTimeStr).Date
    },

    timeStr() {
      return splitDateTimeStrToObj(this.dateTimeStr).Time
    },

    dateTimeStr() {
      return String(this.dateTime || '')
    },

    styles() {
      return {
        lineHeight: this.lineHeight ? this.lineHeight + 'px' : 'auto'
      }
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {splitDateTimeStrToObj}
}
</script>

<style scoped>

</style>
